import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { changePeriodoEditingValue, changePeriodoEditingValuePanoramaCoop, changePeriodoEditingValuePanoramaJornada } from "store/modules/EscolasActions";
import useProgramas from "./useProgramas";

export type PeriodoContexto = 'pufv' | 'coop' | 'jornada';

export const useAtualizarPeriodoAtualDuplicacao = (duplicacao: boolean, contexto: PeriodoContexto) => {
    const escolas = useSelector((escolasState: RootState) => escolasState.escolas);
    const { edicaoPeriodo } = useProgramas();
    const dispatch = useDispatch();

    type Periodo = {
        id: string;
        nomPeriodo: string;
    };

    const { periodoAtual, periodosList } = useSelector((): {
        periodoAtual: string;
        periodosList: Periodo[];
    } => {
        switch (contexto) {
            case 'coop':
                return {
                    periodoAtual: escolas.periodoEditingCoop.periodo,
                    periodosList: escolas.periodoEditingCoop.periodosList,
                };
            case 'jornada':
                return {
                    periodoAtual: escolas.periodoEditingJornada.periodo,
                    periodosList: escolas.periodoEditingJornada.periodosList,
                };
            default:
                return {
                    periodoAtual: escolas.periodoEditing.periodo,
                    periodosList: escolas.periodoEditing.periodosList,
                };
        }
    });

    useEffect(() => {
        if (!duplicacao && !edicaoPeriodo) return;
      
        const anoAtual = new Date().getFullYear().toString();
        const periodoStr = String(periodoAtual || '');
      
        if (!periodoStr.startsWith(anoAtual)) {
          const periodoDoAnoAtual = periodosList.find((p) =>
            p.nomPeriodo.startsWith(anoAtual)
          );
      
          if (periodoDoAnoAtual) {
            const valorPeriodo =
              contexto === 'coop' || contexto === 'jornada'
                ? periodoDoAnoAtual.id
                : periodoDoAnoAtual.nomPeriodo;
      
            switch (contexto) {
              case 'coop':
                dispatch(changePeriodoEditingValuePanoramaCoop('periodo', valorPeriodo));
                break;
              case 'jornada':
                dispatch(changePeriodoEditingValuePanoramaJornada('periodo', valorPeriodo));
                break;
              case 'pufv':
              default:
                dispatch(changePeriodoEditingValue('periodo', valorPeriodo));
                break;
            }
          }
        }
      }, [dispatch, duplicacao, edicaoPeriodo, contexto, periodoAtual, periodosList]);
      
};
